export default {"src":"/_next/static/media/img-landing-hero-bg-3.e4833862.svg","height":512,"width":530,"blurWidth":0,"blurHeight":0};